import { Button } from '@zenterprise-inc/ui';
import cn from 'clsx';
import { ReactNode } from 'react';

import s from '@/components/survey/common/ui/styles/WithButtonList.module.scss';

interface ButtonProps {
  label: string;
  onClick: () => void;
}

interface Props {
  children: ReactNode;
  button: ButtonProps;
  className?: HTMLDivElement['className'];
}

export const WithButtonList = ({ children, button, className }: Props) => {
  return (
    <div className={cn(s.list_wrap, className)}>
      <div className={s.list_left}>{children}</div>
      <Button.Box type={'button'} state={'primary'} onClick={button.onClick}>
        {button.label}
      </Button.Box>
    </div>
  );
};
